import React, { useLayoutEffect, useState } from 'react';
import { Modal, Button, message } from 'antd';
import './Login.css';
import AuthForm from './AuthForm';
import { AuthRole, RoleBar, RoleTiles } from './RoleTiles';

interface MenuRegistrationProps {
  visible: boolean;
  loading: boolean;
  onCancel: () => void;
  onLogin: () => void;
  /** Open straight on this role's form ("Change role" still returns to the tiles). */
  initialRole?: AuthRole;
}

const MenuRegistration: React.FC<MenuRegistrationProps> = ({ visible, loading, onCancel, onLogin, initialRole }) => {
  const [role, setRole] = useState<AuthRole | null>(initialRole ?? null);

  // Each time the modal opens, start on the preselected role's form, or on the role tiles.
  useLayoutEffect(() => {
    if (visible && initialRole) localStorage.setItem('activeTab', initialRole);
    setRole(visible ? initialRole ?? null : null);
  }, [visible, initialRole]);

  const chooseRole = (key: AuthRole) => {
    // AuthForm starts from the stored tab, so keep it in step with the tile that was clicked.
    localStorage.setItem('activeTab', key);
    setRole(key);
  };

  const changeRole = () => {
    localStorage.removeItem('activeTab');
    setRole(null);
  };

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      centered
      className="login-widget-modal"
      width={900}
    >
      <div className="login-widget-container">
        {role === null ? (
          <RoleTiles title="Join enpropeL" subtitle="Choose how you want to join" onSelect={chooseRole} />
        ) : (
          <>
            <RoleBar role={role} onBack={changeRole} />
            <AuthForm
              key={role}
              mode="register"
              defaultTab={role}
              showTabs={false}
              onSuccess={() => {
                message.success('Registration successful! Please login to continue.');
                onLogin(); // Switch to login view after successful registration
              }}
              className="login-widget-form"
            />
          </>
        )}

        <div className="login-widget-footer">
          <span>Already have an account? </span>
          <Button type="link" onClick={onLogin} className="register-link-btn">
            Login
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MenuRegistration;
